/* ============================================================
   Victoria's Gala — Stores interactive map (Leaflet)
   Renders only when #vg-map exists on the page.
   Includes invalidateSize() to fix initial sizing issues.
   ============================================================ */
(function () {
  'use strict';

  var STORES = [
    {
      id: '409',
      name: 'Tienda 409',
      gallery: 'Galería La Torre de Gamarra',
      addr: 'Jr. Hipólito Unanue 1558 esq. Jr. Antonio Bazo 709',
      city: 'La Victoria 15018, Lima',
      waNum: '51944580534',
      waDisplay: '944 580 534',
      waText: 'Hola, quiero visitar la Tienda 409 de Victoria\'s Gala. ¿Me pueden enviar la ubicación y horarios?',
      mapsLink: 'https://www.google.com/maps/search/?api=1&query=Galer%C3%ADa+La+Torre+de+Gamarra+Jr.+Hip%C3%B3lito+Unanue+1558+La+Victoria+Lima',
      lat: -12.06570, lng: -77.01430
    },
    {
      id: '215',
      name: 'Tienda 215',
      gallery: 'Galería Centro de Gamarra',
      addr: 'Jirón Hipólito Unanue 1590',
      city: 'La Victoria 15018, Lima',
      waNum: '51921205082',
      waDisplay: '921 205 082',
      waText: 'Hola, quiero visitar la Tienda 215 de Victoria\'s Gala. ¿Me pueden enviar la ubicación y horarios?',
      mapsLink: 'https://www.google.com/maps/search/?api=1&query=Galer%C3%ADa+Centro+de+Gamarra+Jir%C3%B3n+Hip%C3%B3lito+Unanue+1590+La+Victoria+Lima',
      lat: -12.06530, lng: -77.01450
    },
    {
      id: '424',
      name: 'Tienda 424',
      gallery: 'Galería La Torre de Gamarra',
      addr: 'Jr. Hipólito Unanue 1558 esq. Jr. Antonio Bazo 709',
      city: 'La Victoria 15018, Lima',
      waNum: '51907659325',
      waDisplay: '907 659 325',
      waText: 'Hola, quiero visitar la Tienda 424 de Victoria\'s Gala. ¿Me pueden enviar la ubicación y horarios?',
      mapsLink: 'https://www.google.com/maps/search/?api=1&query=Galer%C3%ADa+La+Torre+de+Gamarra+Jr.+Hip%C3%B3lito+Unanue+1558+La+Victoria+Lima',
      lat: -12.06575, lng: -77.01437
    },
    {
      id: '101',
      name: 'Tienda 101',
      gallery: 'Galería Kristales',
      addr: 'Agustín Gamarra 1095',
      city: 'La Victoria 15018, Lima',
      waNum: '51961267209',
      waDisplay: '961 267 209',
      waText: 'Hola, quiero visitar la Tienda 101 de Victoria\'s Gala. ¿Me pueden enviar la ubicación y horarios?',
      mapsLink: 'https://www.google.com/maps/search/?api=1&query=Galer%C3%ADa+Kristales+Agust%C3%ADn+Gamarra+1095+La+Victoria+Lima',
      lat: -12.06250, lng: -77.01620
    },
    {
      id: '1013',
      name: 'Tiendas 1013 · 1014 · 1015',
      gallery: 'Galería La Torre de Gamarra',
      addr: 'Jr. Hipólito Unanue 1558 esq. Jr. Antonio Bazo 709',
      city: 'La Victoria 15018, Lima',
      waNum: '51932775490',
      waDisplay: '932 775 490',
      waText: 'Hola, quiero visitar una de las tiendas (1013/1014/1015) de Victoria\'s Gala. ¿Me pueden enviar la ubicación y horarios?',
      mapsLink: 'https://www.google.com/maps/search/?api=1&query=Galer%C3%ADa+La+Torre+de+Gamarra+Jr.+Hip%C3%B3lito+Unanue+1558+La+Victoria+Lima',
      lat: -12.06565, lng: -77.01423
    }
  ];

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildPopupHtml(s) {
    var waHref = 'https://wa.me/' + s.waNum + '?text=' + encodeURIComponent(s.waText);
    return ''
      + '<div class="vg-popup">'
      +   '<h4 class="vg-popup__name">' + escapeHtml(s.name) + '</h4>'
      +   '<p class="vg-popup__gallery">' + escapeHtml(s.gallery) + '</p>'
      +   '<p class="vg-popup__addr">' + escapeHtml(s.addr) + '<br>' + escapeHtml(s.city) + '</p>'
      +   '<p class="vg-popup__wa"><strong>WhatsApp:</strong> ' + escapeHtml(s.waDisplay) + '</p>'
      +   '<div class="vg-popup__btns">'
      +     '<a class="vg-popup__btn vg-popup__btn--map" href="' + escapeHtml(s.mapsLink) + '" target="_blank" rel="noopener">Cómo llegar</a>'
      +     '<a class="vg-popup__btn vg-popup__btn--wa" href="' + escapeHtml(waHref) + '" target="_blank" rel="noopener">WhatsApp</a>'
      +   '</div>'
      + '</div>';
  }

  function highlightItem(id) {
    var items = document.querySelectorAll('.vg-store-list-item');
    items.forEach(function (el) {
      el.classList.remove('is-active');
      if (el.getAttribute('data-store') === id) {
        el.classList.add('is-active');
      }
    });
  }

  function waitForLeaflet(callback, attempts) {
    attempts = attempts || 0;
    if (typeof L !== 'undefined') return callback();
    if (attempts > 40) return;
    setTimeout(function () { waitForLeaflet(callback, attempts + 1); }, 250);
  }

  function init() {
    var mapEl = document.getElementById('vg-map');
    if (!mapEl) return;

    waitForLeaflet(function () {
      var map = L.map('vg-map', {
        center: [-12.0645, -77.0150],
        zoom: 17,
        scrollWheelZoom: false,
        zoomControl: true
      });

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors',
        maxZoom: 19
      }).addTo(map);

      var goldIcon = L.divIcon({
        className: 'vg-gold-marker',
        html: '<span></span>',
        iconSize: [30, 42],
        iconAnchor: [15, 42],
        popupAnchor: [0, -38]
      });

      var markers = {};
      var bounds = L.latLngBounds();

      STORES.forEach(function (s) {
        var marker = L.marker([s.lat, s.lng], { icon: goldIcon, title: s.name })
          .addTo(map)
          .bindPopup(buildPopupHtml(s), { maxWidth: 300, className: 'vg-popup-wrap', autoPan: true });
        marker.on('popupopen', function () { highlightItem(s.id); });
        markers[s.id] = marker;
        bounds.extend([s.lat, s.lng]);
      });

      try {
        map.fitBounds(bounds, { padding: [60, 60], maxZoom: 17 });
      } catch (e) {}

      // ✨ FIX: invalidate size after layout settles
      setTimeout(function () { map.invalidateSize(); }, 100);
      setTimeout(function () { map.invalidateSize(); }, 400);
      setTimeout(function () { map.invalidateSize(); }, 1000);
      window.addEventListener('resize', function () {
        map.invalidateSize();
      });
      // Also trigger on visibility / load events
      window.addEventListener('load', function () {
        setTimeout(function () { map.invalidateSize(); }, 200);
      });

      // List click → fly to + open popup
      var items = document.querySelectorAll('.vg-store-list-item[data-store]');
      items.forEach(function (item) {
        function activate() {
          var id = item.getAttribute('data-store');
          var marker = markers[id];
          if (!marker) return;
          highlightItem(id);
          map.flyTo(marker.getLatLng(), 18, { duration: 0.7 });
          setTimeout(function () { marker.openPopup(); }, 400);
        }
        item.addEventListener('click', activate);
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activate();
          }
        });
      });

      map.on('click', function () { map.scrollWheelZoom.enable(); });
      mapEl.addEventListener('mouseenter', function () { map.scrollWheelZoom.enable(); });
      mapEl.addEventListener('mouseleave', function () { map.scrollWheelZoom.disable(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
